import httpManager from "@/app/shared/utils/httpManager";

/**
 * Fetch whatsapp template associated to a channel id
 *
 * @param {Object} params
 * @param {Number} params.templateId Template id
 * @param {Object} params.body Body with the new state
 *
 * @return {Promise<Object>}
 */
export async function updateTemplate({ templateId, body } = {}) {
  await httpManager.put(`/channels/whatsapp-templates/${templateId}/`, body);
}
